export default __webpack_public_path__ + "assets/front/scss/user-profile.1de515488f30b2af4dec9867a2925b90.css";